import { cloneDeep } from 'lodash-es'
import type { CADViewManager } from '@/plugins/cad/module/CADModule/manager/CADViewManager'
import type { IEntity } from '@/plugins/cad/module/CADModule/model/entity'
import { Command } from '@/plugins/cad/module/core/Command'
import type { IUpdateOptions } from '../object/objectManager/BaseObjectManager'

/**
 * 更新实体字段命令，对一组实体批量应用 patch 并支持撤销/重做。
 */
export class UpdateEntityCommand extends Command {
  private originalData: Map<string, Record<string, any>> = new Map()

  constructor(
    private entities: IEntity[],
    private updateData: Record<string, any>,
    private updateOptions: IUpdateOptions = { updateGeometry: true, updateMaterial: false },
    private viewManager: CADViewManager
  ) {
    super()
  }

  /** 记录原始字段并应用 updateData */
  execute(): void {
    this.entities.forEach((entity) => {
      if (this.originalData.has(entity.id)) {
        return
      }
      // 保存原始数据以便撤销
      const original: Record<string, any> = {}
      for (const key in this.updateData) {
        original[key] = cloneDeep(entity[key])
        // 应用更新数据
        entity[key] = cloneDeep(this.updateData[key])
      }
      this.originalData.set(entity.id, original)
    })
    this.viewManager.updateEntities(this.entities, this.updateOptions)
  }

  /** 撤销：按快照恢复实体被修改前的字段值 */
  undo(): void {
    this.entities.forEach((entity) => {
      const original = this.originalData.get(entity.id)
      if (!original) {
        return
      }
      // 恢复原始数据
      Object.assign(entity, cloneDeep(original))
    })
    this.viewManager.updateEntities(this.entities, this.updateOptions)
  }

  /** 重做：再次应用 updateData */
  redo(): void {
    this.entities.forEach((entity) => {
      Object.assign(entity, cloneDeep(this.updateData))
    })
    this.viewManager.updateEntities(this.entities, this.updateOptions)
  }
}
